import { Avatar, AvatarFallback, AvatarImage } from '@app/shared/ui/atoms/Common/Avatar';
import { defaultAvatarFemale, defaultAvatarMale } from '@app/assets';
import { Gender } from '@app/shared/types/common';

interface UserAvatarProps {
  avatar?: string | null;
  isAvatarLoading?: boolean;
  gender?: Gender | null;
  className?: string;
}

export function UserAvatar({
  avatar,
  isAvatarLoading = false,
  gender = 'm',
  className = '',
}: UserAvatarProps) {
  return (
    <Avatar className={className}>
      {!isAvatarLoading && (
        <AvatarImage
          src={avatar ?? (gender === 'm' ? defaultAvatarMale : defaultAvatarFemale)}
          alt="User avatar"
        />
      )}
      <AvatarFallback>U</AvatarFallback>
    </Avatar>
  );
}
